import axios from "axios";

export function Fn_activeAxiosEtc(rootStore) {
    const apiUrl = rootStore.settingStore.ActiveRestUrl.tpayApi;
    rootStore.layerStore.setDeliveryErrMsg("");
    const instance = axios.create({
        baseURL:apiUrl,
        timeout: 25000,
    });
    instance.interceptors.request.use(function (config) {
        rootStore.layerStore.setLayerLoadingView(true)
        return config;
    }, function (error) {
        rootStore.layerStore.setLayerLoadingView(false)
        return Promise.reject(error);
    });
    instance.interceptors.response.use(
        function (response) {
            rootStore.layerStore.setLayerLoadingView(false)
            return response;
        },
        function (error) {
            rootStore.layerStore.setLayerLoadingView(false)
            return Promise.reject(error);
        }
    );

    return instance;
}